/**
 * Extracts text content from various message content formats
 * @param {string|Array|Object} content - The message content
 * @returns {string} - Extracted text
 */
export const extractTextFromContent = (content) => {
  if (!content) return '';

  let parsedContent = content;

  // Parse JSON string if needed
  if (typeof content === 'string' && (content.startsWith('[') || content.startsWith('{'))) {
    try {
      parsedContent = JSON.parse(content);
    } catch {
      return content;
    }
  }

  // Extract text based on type
  if (typeof parsedContent === 'string') {
    return parsedContent;
  }

  if (Array.isArray(parsedContent)) {
    return parsedContent
      .filter(part => part && part.type === 'text')
      .map(part => part.text)
      .join(' ');
  }

  if (typeof parsedContent === 'object') {
    return parsedContent.text || parsedContent.message || '';
  }

  return '';
};
